import { render } from "./ProductToCustomerPrices.vue?vue&type=template&id=e743ba88&ts=true"
import script from "./ProductToCustomerPrices.vue?vue&type=script&lang=ts"
export * from "./ProductToCustomerPrices.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\caffeine\\caffeineshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__